import { Alert as UiKitAlert, type AlertProps as UiKitAlertProps } from "zhihao-ui-react";
import type { ReactNode } from "react";

/** 统一页面内提示样式，同时兼容 Ant Design Alert 的 message/title 两种旧文案写法。 */
export type PageAlertProps = Omit<UiKitAlertProps, "title"> & {
    message?: ReactNode;
    title?: ReactNode;
};

/** 页面提示统一使用 UI Kit Alert，确保错误、警告和信息条的尺寸与视觉保持一致。 */
export const PageAlert = ({ message, title, description, ...props }: PageAlertProps) => {
    const alertTitle = title ?? message;
    // Ant Alert 允许仅传 description；UI Kit 需将其放入标题位，避免出现组件默认占位标题。
    const hasDescriptionOnly = alertTitle == null && description != null;

    return (
        <UiKitAlert
            {...props}
            title={hasDescriptionOnly ? description : alertTitle}
            description={hasDescriptionOnly ? undefined : description}
        />
    );
};
